import styled from 'styled-components';
import CustomCard from '@components/CustomCard';

export const CardContainer = styled(CustomCard)`
  .card-title {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.text};

    .ant-tabs {
      padding: 0;
    }

    .ant-tabs-tab {
      margin: 0;

      .ant-tabs-ink-bar {
        padding: 20px;
      }
    }

    .ant-radio-group {
      z-index: 0;
    }

    .ant-radio-button-wrapper {
      margin: 0;
      flex-wrap: wrap;

      span {
        font-weight: normal;
      }
    }

    @media (max-width: 500px) {
      justify-content: center;

      .ant-radio-group {
        margin-top: 16px;
      }
    }
  }

  .ant-card-body {
    padding-top: 16px !important;
    padding-right: 24px !important;
  }

  [data-chart-source-type='G2Plot'] {
    > div {
      z-index: 0;
    }
  }

  .g2-html-annotation {
    opacity: 0.8;
    font-size: 1.4rem !important;
    color: ${({ theme }) => theme.colors.text1} !important;
  }

  .g2-html-annotation + .g2-html-annotation {
    margin-top: 8px !important;
    font-size: 1.8rem !important;
    color: ${({ theme }) => theme.colors.text} !important;
  }
`;
